/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2020 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { addToListLinkStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsAddToListLink";
import getColor from "@insite/mobius/utilities/getColor";
import { sharedProductAddToListLinkStyles } from "@monsma/XDL/Utilities/sharedStyles";
import { css } from "styled-components";

addToListLinkStyles.wrapper = {
    css: css`
        &:not(.able-to-add-to-cart) {
            padding-top: 20px;
            border-top: 1px solid ${getColor("common.ui12")};
            margin-top: 25px;
        }
    `,
};

addToListLinkStyles.link = sharedProductAddToListLinkStyles;
